import { getUrlWithCode, UseOpenTractiveReferralResult } from './useOpenTractiveReferral.common';

const useOpenTractiveReferral = (tractiveCode: string): UseOpenTractiveReferralResult => {
  const url = getUrlWithCode(tractiveCode);
  return {
    openTractiveReferral: () => window.open(url, '_blank'),
  };
};

export default useOpenTractiveReferral;
